import React from 'react'
import {Select} from "antd"

const {Option} = Select

const SelectSearch = (props) => {
    const {listSelect, name, value, label} = props

    const _handleChangeSelect = (value) => {
        props.onChange(name, value)
    }

    return (
        <div className="FilterSelect">
            <label htmlFor={name}>{label}</label>

            <Select
                showSearch
                id={name}
                style={{width: '100%'}}
                defaultValue=""
                value={value}
                onChange={_handleChangeSelect}
                placeholder={"Chọn khách hàng"}
                filterOption={(input, option) => (option.children).toLowerCase().includes(input.toLowerCase())}
            >
                {
                    listSelect.map(item => {
                        return <Option value={item.value} key={item.value}>{item.name}</Option>
                    })
                }
            </Select>
        </div>
    )
}

export default SelectSearch
